import { Text, View, NodeProps } from "@react-pdf/renderer";

type Style = NodeProps["style"];

interface TableColPdfProps {
  title: string;
  content?: string;
  styleBox?: Style;
  styleBoxTitle?: Style;
  styleTitle?: Style;
  styleContent?: Style;
  children?: React.ReactNode;
  hiddenHeader?: boolean;
  /** Enables line breaks inside CJK / no-space tokens (react-pdf only splits on spaces by default). */
  hyphenationCallback?: (word: string) => string[];
}

/**
 *TableColPdf
 *@param {TableColPdfProps} - props
 */
export default function TableColPdf({
  content,
  styleBox,
  styleBoxTitle,
  styleTitle,
  styleContent,
  title,
  children,
  hiddenHeader,
  hyphenationCallback,
}: TableColPdfProps) {
  return (
    <View style={{ width: 50, alignSelf: "stretch", ...styleBox }}>
      {!hiddenHeader && (
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#ffcc00",
            minHeight: 22,
            paddingVertical: 2,
            paddingHorizontal: 2,
            ...styleBoxTitle,
          }}
        >
          <Text
            hyphenationCallback={hyphenationCallback}
            style={{
              fontWeight: "bold",
              fontSize: 8,
              textAlign: "center",
              width: "100%",
              ...styleTitle,
            }}
          >
            {title}
          </Text>
        </View>
      )}

      {typeof content === "string" && (
        <Text
          hyphenationCallback={hyphenationCallback}
          style={{
            fontSize: 8,
            paddingHorizontal: 2,
            textAlign: "center",
            marginTop: 2,
            width: "100%",
            flexGrow: 0,
            flexShrink: 1,
            ...styleContent,
          }}
        >
          {content}
        </Text>
      )}
      {children}
    </View>
  );
}
